export default function FormFooter({children}){
    return (
        <p className="text-center font-Outfit font-light text-base text-textColor mt-8">
            {children}
        </p>
    );
}